import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  STRING_ACCESS_TOKEN_ULTIMA_MILLA_V3,
  STRING_ID_EMPRESA_ULTIMA_MILLA_V3, STRING_LANGUAGE_ULTIMA_MILLA,
  STRING_SIDEBAR_EXPANDED_UMV3, STRING_ID_ROL_USUARIO_WEB, STRING_ID_TIPO_USUARIO_WEB
} from "../utils/const/string-const";

export default function Salir() {
  const history = useHistory();
  const clearData = (page, params) => {
    try {
      // console.log('clearData');
      if (params !== undefined && params !== null) {
        if (params.acciones !== undefined) {
          delete params.acciones;
        }
        history.push({
          pathname: `${page}`,
          state: params,
        });
        // history.push(`/`);
      } else {
        history.push(`${page}`);
        // history.push(`/`);
      }
      // console.log('end clearData');
    } catch (e) {
      console.error(e.message);
    }
  };

  useEffect(() => {
    // console.log('useEffect');
    localStorage.removeItem(STRING_LANGUAGE_ULTIMA_MILLA);
    localStorage.removeItem(STRING_ACCESS_TOKEN_ULTIMA_MILLA_V3);
    localStorage.removeItem(STRING_SIDEBAR_EXPANDED_UMV3);
    localStorage.removeItem(STRING_ID_EMPRESA_ULTIMA_MILLA_V3);
    localStorage.removeItem(STRING_ID_ROL_USUARIO_WEB);
    localStorage.removeItem(STRING_ID_TIPO_USUARIO_WEB);
    clearData("login");
    // console.log('end useEffect');
  }, []);

  return <div className="p-[2rem]"></div>;
}
